function waitForGlobal(key, callback) {
  if (window[key] && Object.keys(window[key]).length > 0) {
    callback();
  } else {
    setTimeout(function () {
      waitForGlobal(key, callback);
    }, 100);
  }
}

export default waitForGlobal;
